import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SurveyClosedPreview from './pages/SurveyClosedPreview';
import SurveyClosed from './pages/SurveyClosed';
import SurveyTaken from './pages/SurveyTaken';
import SurveyThanks from './pages/SurveyThanks';
import SurveyTaking from './pages/SurveyTaking';
import QuizResult from './pages/QuizResult';
import EnterpriseThankYou from './pages/EnterpriseThankYou';
import EnterpriseThankYouV2 from './pages/EnterpriseThankYouV2';

const App = () => {
  return (
    <Switch>
      <Route path="/survey-closed/preview/" component={SurveyClosedPreview} />
      <Route path="/survey-closed/" component={SurveyClosed} />
      <Route path="/survey-taken/" component={SurveyTaken} />
      <Route path="/survey-thanks/" component={SurveyThanks} />
      <Route path="/quiz-result/" component={QuizResult} />
      <Route path="/enterprise-thank-you/" component={EnterpriseThankYou} />
      <Route path="/enterprise-thank-you-v2/" component={EnterpriseThankYouV2} />
      <Route path="/rx/" component={SurveyTaking} />
    </Switch>
  );
};

export default App;
